import f from "../../../@babel/runtime/helpers/esm/slicedToArray.mjs";
import * as r from "react";
import c from "../../../rc-util/es/Dom/canUseDom.mjs";
var o = 0, i = process.env.NODE_ENV !== "test" && c();
function u() {
  var t;
  return i ? (t = o, o += 1) : t = "TEST_OR_SSR", t;
}
function _(t) {
  var n = r.useState(), e = f(n, 2), s = e[0], a = e[1];
  return r.useEffect(function() {
    a("rc_select_".concat(u()));
  }, []), t || s;
}
export {
  _ as default,
  u as getUUID,
  i as isBrowserClient
};
//# sourceMappingURL=useId.mjs.map
